import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { push } from 'react-router-redux'
import TextTruncate from 'react-text-truncate'
import ReactTooltip from 'react-tooltip'
import { OEComponents } from '@opportunityeducation/oe-web-common'

import MarkdownLabel from './MarkdownLabel'
import NotYetSpecified from './NotYetSpecified'
import IntendedCourseLevel from './IntendedCourseLevel'
import QuestIcon from './QuestIcon'
import QuestStatus from './QuestStatus'
import QuestListItemAssignment from './QuestListItemAssignment'
import Caption1 from '../typography/captions/Caption1'
import PriorityIndicator from './PriorityIndicator'

import { setQuestSection } from '../../actions/quest'
import {
  questIsAssignedByUser,
  questIsAssignedToUser
} from '../../utils/assignment'
import { getUserDisplayName } from '../../utils/name'
import { questIsPublished, getReviewStatus } from '../../utils/review'
import { getAuthors } from '../../utils/quest'

export default class QuestListItem extends Component {
  constructor(props) {
    super(props)
    this.onClickBound = this.onClick.bind(this)
  }

  render() {
    const { quest, clickHandler, user } = this.props
    const reviewStatus = getReviewStatus(quest)

    // some places tags are a string, others they are an array
    // gotcha - sometimes tags are null, especially when in review queue
    const tags =
      quest.tags && typeof quest.tags === 'object'
        ? quest.tags.join(', ')
        : quest.tags

    return (
      <li
        className="quest-list-item"
        onClick={clickHandler || this.onClickBound}
      >
        <div className="quest-list-item-quest-data">
          <ReactTooltip
            id="tagsTooltip"
            effect="solid"
            offset={{ bottom: 10 }}
          />
          <ReactTooltip
            id="subjectTooltip"
            effect="solid"
            offset={{ bottom: 10 }}
          />
          <ReactTooltip
            id="targetGradeLevelTooltip"
            effect="solid"
            offset={{ bottom: 10 }}
          />

          <div className="left">
            <QuestIcon
              heightWidth={this.props.iconHeightWidth}
              icon_image_url={quest.icon_image_url}
              showTypeIcon={quest.type && Boolean(quest.type.id)}
              questTypeId={quest.type ? quest.type.id : null}
              questTypeIconSize={28}
            />
          </div>

          <div className="middle">
            {quest.mock_course && <IntendedCourseLevel quest={quest} />}

            <div className="h1 name">
              <TextTruncate line={2} truncateText="..." text={quest.name} />
            </div>
            <div className="p1 authors">
              {getAuthors({
                authors: quest.authors,
                questId: quest.id
              })}
            </div>
            {quest.description && quest.description.length > 0 && (
              <MarkdownLabel
                id="view-description"
                value={quest.description}
                additionalCssClasses="description"
              />
            )}
            {quest.driving_question && quest.driving_question.length > 0 && (
              <div className="p2 driving-question">
                <MarkdownLabel value={quest.driving_question} />
              </div>
            )}
            <div className="caption1 metadata">
              <div className="primary-subject-tags-container">
                <div className="primary-subject-wrapper">
                  <div
                    className="icon-wrapper"
                    data-for="subjectTooltip"
                    data-tip="Primary Subject"
                  >
                    <div className="primary-subject" />
                  </div>
                  <p>
                    {quest.subject && quest.subject.name ? (
                      quest.subject.name
                    ) : (
                      <NotYetSpecified hideCircleIcon textClass="caption1" />
                    )}
                  </p>
                </div>
                <div className="tags-wrapper">
                  <div
                    className="icon-wrapper"
                    data-for="tagsTooltip"
                    data-tip="Tags"
                  >
                    <div className="tags" />
                  </div>
                  <p>
                    {tags && tags.length > 0 ? (
                      tags
                    ) : (
                      <NotYetSpecified hideCircleIcon textClass="caption1" />
                    )}
                  </p>
                </div>
              </div>

              <div className="target-grade-level-wrapper">
                <div
                  className="icon-wrapper"
                  data-for="targetGradeLevelTooltip"
                  data-tip="Target Grade"
                >
                  <div className="target-grade-level" />
                </div>
                <p>
                  {quest.grade_levels && quest.grade_levels.length > 0 ? (
                    this.formatGradeLevels()
                  ) : (
                    <NotYetSpecified hideCircleIcon textClass="caption1" />
                  )}
                </p>
              </div>
            </div>
          </div>

          <div className="right">
            <div style={{ display: 'flex' }}>
              <QuestStatus status={reviewStatus} />
              {quest.priority !== 'normal' && (
                <div
                  style={{
                    marginLeft: '15px',
                    display: 'inline-block',
                    verticalAlign: 'bottom',
                    marginTop: '3px'
                  }}
                >
                  <PriorityIndicator
                    priority={quest.priority}
                    questId={quest.id}
                  />
                </div>
              )}
            </div>
            <Caption1
              style={{
                color: '#000000',
                marginTop: '8px'
              }}
            >
              {`ID: ${quest.id}\xa0\xa0Version: ${quest.current_version}`}
            </Caption1>
            <div className="last-saved-by-container">
              {questIsPublished(quest) ? (
                <div className="caption1 published-date">
                  <OEComponents.DateFormatter
                    date={quest.reviewing_compiled_quest.published_at}
                    includeTime={false}
                  />
                </div>
              ) : (
                <React.Fragment>
                  <div className="caption1 last-saved">
                    {'Last saved '}
                    <OEComponents.DateFormatter
                      date={quest.updated_at}
                      includeTime={false}
                    />
                  </div>
                  <div className="caption1 updated-by">
                    <TextTruncate
                      line={1}
                      truncateText="..."
                      text={`by ${
                        quest.last_updated_by
                          ? getUserDisplayName(quest.last_updated_by)
                          : 'Unknown'
                      }`}
                    />
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
          <div
            className="caption1 current-version"
            style={{
              position: 'absolute',
              right: '0',
              bottom: '0',
              padding: 'inherit'
            }}
          >
            {`v${quest.current_version}`}
          </div>
        </div>

        {quest.assigned_to && !questIsPublished(quest) && (
          <QuestListItemAssignment
            assignedTo={quest.assigned_to}
            assignedBy={quest.assigned_by}
            message={quest.assignment_message}
            updatedAt={quest.assignment_updated_at}
            clickHandler={this.onQuestClickBound}
            questIsAssignedToUser={questIsAssignedToUser(quest, user)}
            questIsAssignedByUser={questIsAssignedByUser(quest, user)}
            assignmentType={quest.assignment_type}
          />
        )}
      </li>
    )
  }

  formatGradeLevels() {
    return (
      <span>
        {this.props.quest.grade_levels
          .map(gradeLevel => gradeLevel.name)
          .join(', ')}
      </span>
    )
  }

  onClick() {
    const { dispatch, quest, isCompiledQuest, navToSection } = this.props
    const section = navToSection ? navToSection : 'basicinformation'
    dispatch(setQuestSection(section))
    dispatch(
      push(`/quest/${!isCompiledQuest ? quest.id : quest.quest_id}/${section}`)
    )
  }
}

QuestListItem.propTypes = {
  quest: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  isCompiledQuest: PropTypes.bool,
  clickHandler: PropTypes.func,
  user: PropTypes.object,
  navToSection: PropTypes.string,
  iconHeightWidth: PropTypes.number.isRequired
}



// WEBPACK FOOTER //
// ./src/components/mini/QuestListItem.js